import React from "react";
import { Card } from "@libertify/ui";
import { PlaybookAddOnTitle } from "./PlaybookAddOnTitle";
import type { ConfigItemVisualId } from "../data/addons";

interface PlaybookAddOnCardProps {
  itemId: ConfigItemVisualId;
  title: string;
  /** Estimated credit cost, shown as "~{credits} cr". Omit (or 0) to hide the
   *  badge for free items like Documents. */
  credits?: number;
  description: string;
  /** Viewer-visibility of the add-on. Passing `onVisibleChange` puts the
   *  "Visible" toggle in the card header (see PlaybookAddOnTitle). */
  visible?: boolean;
  onVisibleChange?: (visible: boolean) => void;
  /** Disables the "Visible" toggle with a spinner while a request is in flight. */
  visiblePending?: boolean;
  children?: React.ReactNode;
}

/**
 * Generic settings-card shell for a playbook add-on (icon + title + credit
 * estimate + description in the header, form fields as children in the body).
 * Wraps the shared `Card` so the header/body divider comes for free.
 */
export const PlaybookAddOnCard: React.FC<PlaybookAddOnCardProps> = ({
  itemId,
  title,
  credits,
  description,
  visible,
  onVisibleChange,
  visiblePending,
  children,
}) => {
  return (
    <Card
      title={
        <PlaybookAddOnTitle
          itemId={itemId}
          title={title}
          credits={credits}
          description={description}
          visible={visible}
          onVisibleChange={onVisibleChange}
          visiblePending={visiblePending}
        />
      }
    >
      {children}
    </Card>
  );
};

export default PlaybookAddOnCard;
